var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { translate } from '@utils/i18n';
import { updateKitOrderStatus } from '../services/SprinklerSamplingService';
import { kitOrderKeys } from './queryKeys';
import { KIT_ORDERS_NAMESPACE, KIT_ORDER_STATUS } from '../constants';
export function useUpdateKitOrderStatusMutation() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (_a) => __awaiter(this, [_a], void 0, function* ({ id, status }) {
            const response = yield updateKitOrderStatus(id, status);
            if (response.error)
                throw new Error(response.error.message);
            return response.data;
        }),
        onSuccess: (data) => {
            const messageKey = data.status === KIT_ORDER_STATUS.COMPLETED ? 'kit_orders.marked_as_received' : 'kit_orders.marked_as_sent';
            toast.success(translate(messageKey, { namespace: KIT_ORDERS_NAMESPACE }));
            void queryClient.invalidateQueries({ queryKey: kitOrderKeys.all });
        },
        onError: (error) => {
            toast.error(error.message ||
                translate('kit_orders.status_error', {
                    namespace: KIT_ORDERS_NAMESPACE,
                    defaultValue: 'Failed to update status'
                }));
            void queryClient.invalidateQueries({ queryKey: kitOrderKeys.all, refetchType: 'active' });
        }
    });
}
